const KEY_PREFIX = 'masha:rewrite-feedback:';

function key(sessionId: number): string {
  return KEY_PREFIX + sessionId;
}

export function saveFeedback(sessionId: number, text: string): void {
  try {
    window.sessionStorage.setItem(key(sessionId), text);
  } catch {
    // sessionStorage full / unavailable; ignore
  }
}

export function loadFeedback(sessionId: number): string {
  try {
    return window.sessionStorage.getItem(key(sessionId)) ?? '';
  } catch {
    return '';
  }
}

export function clearFeedback(sessionId: number): void {
  try {
    window.sessionStorage.removeItem(key(sessionId));
  } catch {
    // ignore
  }
}
